import Page from "@/components/Page";
import {
	DsHeader,
	DsKpi,
	DsKpiRow,
	DsPreviewNotice,
	DsSection,
	DsStatus,
	DsTable,
} from "@/components/DsKit";

import {formatEuro} from "@/utils/clubSnapshot";

// Area interamente dimostrativa: nessun modulo commerciale è ancora attivo
const SAMPLE_SPONSORS = [
	{
		id: 1,
		name: "Sponsor principale (maglia)",
		value: 40000,
		expiry: "Giu 2028",
		status: "ok",
	},
	{
		id: 2,
		name: "Sponsor tecnico",
		value: 15000,
		expiry: "Giu 2027",
		status: "warn",
	},
	{
		id: 3,
		name: "Sponsor sul retro",
		value: 12000,
		expiry: "Giu 2027",
		status: "warn",
	},
	{
		id: 4,
		name: "Partner settore giovanile",
		value: 8000,
		expiry: "Dic 2026",
		status: "alert",
	},
	{
		id: 5,
		name: "Cartellonistica campo",
		value: 10000,
		expiry: "Giu 2028",
		status: "ok",
	},
];

const SAMPLE_EVENTS = [
	{
		id: 1,
		name: "Porte aperte scuola calcio",
		when: "Sab 7 novembre",
		status: "ok",
	},
	{
		id: 2,
		name: "Torneo di Natale Under 12",
		when: "20-21 dicembre",
		status: "warn",
	},
	{id: 3, name: "Cena sponsor di fine anno", when: "12 dicembre", status: "ok"},
];

function DsCommercialPage() {
	return (
		<Page>
			<div className="ds">
				<DsHeader
					title="Commerciale & comunicazione"
					subtitle="Sponsor, iniziative e presenza del club"
				/>
				<DsPreviewNotice />
				<DsKpiRow>
					<DsKpi label="Sponsor attivi" value={SAMPLE_SPONSORS.length} />
					<DsKpi
						label="Valore contratti"
						value={formatEuro(
							SAMPLE_SPONSORS.reduce((n, sp) => n + sp.value, 0),
						)}
						sub="annuo"
					/>
					<DsKpi
						label="In scadenza"
						value="3"
						tone="yellow"
						sub="entro fine stagione"
					/>
					<DsKpi label="Seguaci sui social" value="4.8k" sub="+6% nel mese" />
				</DsKpiRow>

				<DsSection title="Sponsor" preview>
					<DsTable
						columns={[
							{key: "name", label: "Contratto", render: (r) => <b>{r.name}</b>},
							{
								key: "value",
								label: "Valore annuo",
								align: "right",
								render: (r) => formatEuro(r.value),
							},
							{
								key: "expiry",
								label: "Scadenza",
								render: (r) => <DsStatus status={r.status} label={r.expiry} />,
							},
						]}
						rows={SAMPLE_SPONSORS}
					/>
				</DsSection>

				<DsSection title="Eventi in programma" preview>
					<div className="ds-list">
						{SAMPLE_EVENTS.map((e) => (
							<div key={e.id} className="ds-list__item">
								<div className="ds-list__main">
									<div className="ds-list__title">{e.name}</div>
									<div className="ds-list__sub">{e.when}</div>
								</div>
								<DsStatus status={e.status} />
							</div>
						))}
					</div>
				</DsSection>
			</div>
		</Page>
	);
}

export default DsCommercialPage;
